import { apiClient, getAccessToken } from './client';
import { API_ROUTES } from './routes';

export const jobService = {
  async getPresignedUrl(filename, contentType = 'video/mp4') {
    const response = await apiClient.post(API_ROUTES.TRANSCRIPTIONS.PRESIGNED, { 
      filename,
      content_type: contentType 
    });
    return response?.data || null;
  },

  async uploadToGCS(uploadUrl, file) {
    // Read file as ArrayBuffer for reliable binary upload to GCS
    const arrayBuffer = await file.arrayBuffer();
    
    // Do NOT set Content-Type - the presigned URL signature doesn't include it
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: arrayBuffer,
    });
    
    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Unknown error');
      throw new Error(`Failed to upload file: ${response.status} - ${errorText}`);
    }
  },

  async submitJob(gcsUri, filename, options = {}) {
    const payload = {
      gcs_uri: gcsUri,
      filename,
      ...options
    };
    const response = await apiClient.post(API_ROUTES.TRANSCRIPTIONS.SUBMIT, payload);
    return response?.data || null;
  },

  async getJob(id) {
    const response = await apiClient.get(API_ROUTES.TRANSCRIPTIONS.GET(id));
    return response?.data || null;
  },

  async listJobs(page = 1, pageSize = 10, status) {
    const response = await apiClient.get(API_ROUTES.TRANSCRIPTIONS.BASE, {
      params: {
        page,
        page_size: pageSize,
        status
      }
    });
    return response?.data || null;
  },

  async deleteJob(id) {
    await apiClient.delete(API_ROUTES.TRANSCRIPTIONS.DELETE(id));
  },

  streamProgress(id, onEvent) {
    const token = getAccessToken();
    const url = new URL(API_ROUTES.TRANSCRIPTIONS.STREAM(id));
    if (token) {
      url.searchParams.set('token', token);
    }

    const eventSource = new EventSource(url.toString());
    const handleEvent = (event) => {
      if (onEvent) {
        onEvent(event);
      }
    };
    if (onEvent) {
      eventSource.onmessage = handleEvent;
    }
    // Ensure named events are forwarded to the same handler
    ['status', 'progress', 'completed', 'error', 'ping'].forEach((eventName) => {
      eventSource.addEventListener(eventName, handleEvent);
    });
    return eventSource;
  }
};
